import {createSelector} from 'reselect';
import {selectEventOriginCountry} from '../../common/higherOrderComponents/withEvents/selectors';
import {ticketCountSelector} from '../../common/higherOrderComponents/withTickets/utils';
import {ticketTypeSelectedSelector} from '../../store/sellTicket/selectors';

export const selectSeatDetails = createSelector(
  (state) => state && state['seat-details'] || {},
  (seatDetails) => seatDetails || {}
);

export const selectedFeaturesIsValid = createSelector(
  selectSeatDetails,
  (seatDetails) => ['restrictions', 'limitations', 'connections'].every((feature) => (
    seatDetails[`${feature}Valid`]
  ))
);

export const isSeatDetailsValid = createSelector(
  selectedFeaturesIsValid,
  selectEventOriginCountry,
  (featuresValid, eventOriginCountry) => {
    if (eventOriginCountry === 'GB') {
      return featuresValid;
    }

    return true;
  }
);

export const shouldRestrictPdfSeatDetailsVisibilitySelector = createSelector(
  ticketCountSelector,
  ticketTypeSelectedSelector,
  (ticketCount, ticketTypeSelected) => {
    return !ticketCount && ticketTypeSelected === 'PDF';
  }
);
